export default __webpack_public_path__ + "static/media/currency_exchange.08226b06.svg";